// tslint:disable: no-shadowed-variable
import Vue from 'vue'
import Vuex, { MutationTree, ActionTree } from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import Permissions from '../models/constants/Permissions'
Vue.use(Vuex)

interface Schools {
  etablissement_id: number
  nom: string
}
export interface User {
  accountExpires: Date
  givenName: string
  lastLogin: Date
  mail: string
  sAMAccountName: string
  sn: string
  userAccountControl: number
  identifiant: string
  secondaryMail: string
  isStudent: string
  roles: string[]
  permissions: Permissions[]
  jobTitles: string
  additionalJobTitles: string[]
  schools: Schools[]
  classes: string[]
  annees: string[]
  mustChangePassword?: boolean
  isStaff: boolean
  isDataSteward: boolean
  authority?: string
  department?: string
  entity?: string
  unit?: string
}
interface State {
  isLogged: boolean
  refreshToken: string
  accessToken: string
  user?: User
  key: string
}

const state: State = {
  isLogged: false,
  refreshToken: '',
  accessToken: '',
  key: '',
}

const mutations: MutationTree<State> = {
  setLogged(state, logged: boolean) {
    state.isLogged = logged
  },
  setRefreshToken(state, token: string) {
    state.refreshToken = token
  },
  setAccessToken(state, token: string) {
    state.accessToken = token
  },
  setUser(state, user: any) {
    state.user = user
  },
  setKey(state, key: string) {
    state.key = key
  },
}

const actions: ActionTree<State, State> = {
  logout({ commit }) {
    commit('setLogged', false)
    commit('setAccessToken', '')
    commit('setRefreshToken', '')
    commit('setUser', {})
    commit('setKey', '')
  },
}

const store = new Vuex.Store({
  state,
  mutations,
  actions,
  plugins: [
    createPersistedState({
      key: 'cipeo-admanagement-vuex',
    }),
  ],
})

export default store
